<template>
    <router-view />
</template>

<script>
export default {
  name: 'App',

}
</script>

<style>
@import url('./assets/css/init.css');
html,body{
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f4f4f4;
  height: 100%;
  
}

</style>
